import store from '../store/index'

import pendingReaction from '../assets/images/bbPendingReaction.png'
import blankAction from '../assets/images/bbBlankAction.png'
//----------------------
// load reaction values
//----------------------
export default function loadReactionValues(reactions) {
  console.log('----------------------')
  console.log('IN loadReactionValues')
  //--------------
  // access store
  //--------------
  const this_store = store.state.combat
  let combatants = this_store.arena.arena_combatants
  let maxCR = this_store.config.max_cr

  if (combatants) {
    //----------------------
    // loop thru combatants
    //----------------------
    for (let i = 0; i < combatants.length; i++) {
      //-------------------------
      // where active combatants
      //-------------------------
      if (combatants[i].status == 'Active') {
        //----------------------
        // loop possible max cr
        //----------------------
        for (let k = 1; k <= maxCR; k++) {
          //------------------
          // set var cr props
          //------------------
          let cr = 'cr' + k
          let cr_name = 'cr_name' + k
          let cr_slug = 'cr_slug' + k
          let match_reaction_idx = -1
          //----------------------------------------
          // get reaction for cr number + combatant
          //----------------------------------------
          if (reactions) {
            match_reaction_idx = reactions.findIndex(
              (a) => a.combatant == combatants[i].id && a.number === k,
            )
          }
          //-----------------------------
          // where got reaction for slot
          //-----------------------------
          if (match_reaction_idx != -1) {
            combatants[i][cr] = reactions[match_reaction_idx].reaction_image
            combatants[i][cr_name] = reactions[match_reaction_idx].reaction_name
            combatants[i][cr_slug] = reactions[match_reaction_idx].slug
            //----------------------------
            // where no reaction for slot
            //----------------------------
          } else {
            if (k <= combatants[i].cr) {
              combatants[i][cr] = pendingReaction
              combatants[i][cr_name] = 'pending'
              combatants[i][cr_slug] = ''
            } else {
              combatants[i][cr] = blankAction
              combatants[i][cr_name] = 'blank'
              combatants[i][cr_slug] = ''
            }
          }
        }
        //------------------------------------------------------------------------------
        // get idx for combatant from reaction (count per round stored in each reaction)
        //-------------------------------------------------------------------------------
        let match_reactionid_idx = -1
        if (reactions) {
          match_reactionid_idx = reactions.findIndex(function (a) {
            return a.combatant === combatants[i].id
          })
        }
        //-----------------------------------------------------
        // if found - store reaction count for combatant/round
        //-----------------------------------------------------
        if (match_reactionid_idx != -1) {
          combatants[i].reaction_count = reactions[match_reactionid_idx].reaction_count
        } else {
          combatants[i].reaction_count = 0
        }
      }
    }
  }
}
